<template>
  <Form :model="feeItem" :label-width="90" :rules="formRules" :ref="`formData${i}`">
    <FormItem :label-width="80" class="inline-b" label="费用项：" prop="expenseItemId">
      <Select v-model="feeItem.expenseItemId" class="item-width">
        <Option v-for="item in feeItems" :value="item.value" :key="item.value">{{item.text}}</Option>
      </Select>
    </FormItem>
    <FormItem :label-width="120" class="inline-b" label="应收金额：" prop="oughtAmount">
      <Input type="text" v-model="feeItem.oughtAmount" class="item-width">
         <span slot="append">元</span>
      </Input>
    </FormItem>
  </Form>
</template>
 
<script type="text/ecmascript-6">
export default {
  props:{
    i:{
      type:Number,
      default:0
    },
    roomId:{
      type:String,
      default:''
    },
    feeItems:{
      type:Array,
      default:()=> {
        return []  
      }
    },
    n:{
      type:Number,
      default:0
    }
  },
  watch:{
    n(){
      this.$refs[`formData${this.i}`].resetFields(); 
    }
  },
  data () {
    const validatePrice = (rule, value, callback)=>{
      const pattern = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/  
      if(pattern.test(value)){  
        this.$emit('inputPayment')
        callback();
      }else {
        callback(new Error('输入正确的数字'));
      }
    }
    return {
      feeItem:{
        expenseItemId:'',
        oughtAmount:''
      },
      formRules:{
        expenseItemId:[ { required:true, message:'选择费用项', type:'number', trigger:'change' } ],
        oughtAmount:[{ required:true,  validator:validatePrice, trigger:'blur' } ]
      }
    };
  },
  methods:{
    deleteItem(){
      this.$emit('delete-item',this.i)
    },
    formValidate() {     
      let obj = {}
      this.$refs[`formData${this.i}`].validate( bool => {
        if(bool){
          obj = {
            expenseItemId:+this.feeItem.expenseItemId,
            oughtAmount:+this.feeItem.oughtAmount,
            roomId:this.roomId
          }
        }else{
            obj = false
        }
      })
      return obj
    },
  }
}
</script>
 
<style lang="css" scoped>
 
</style>